const licenseType = {
  1: '一级建造师',
  2: '二级建造师',
  3: '注册造价师',
  10: '市政五大员',
  11: '水利五大员',
  12: '市政安全员',
  13: '水利安全员',
  14: '特殊工种',
  15: '职称证'
}
const licenseStatus = {
  1: '未生效',
  2: '生效中',
  3: '已过期'
}
const borrowStatus = ['待批准借阅', '已批准借阅', '未批准借阅', '已归还借阅']


import oaFlowData203 from '@/assets/img/oaFlowData203@3x.png'  // 工程处罚通知单
import oaFlowData200 from '@/assets/img/oaFlowData200@3x.png'  // 工程项目检查意见单
import oaFlowData201 from '@/assets/img/oaFlowData201@3x.png'  // 工程项目整改通知单
import oaFlowData202 from '@/assets/img/oaFlowData202@3x.png'  // 工程项目停工通知单
import oaFlowData171 from '@/assets/img/oaFlowData171@3x.png'  // 劳务管理
import oaFlowData172 from '@/assets/img/oaFlowData172@3x.png'  // 机械管理
import oaFlowData173 from '@/assets/img/oaFlowData173@3x.png'  // 材料管理
import oaFlowData192 from '@/assets/img/oaFlowData192@3x.png'  // 机械台班考勤上报
import flowdata164 from '@/assets/img/flowData164@3x.png'  // 固定资产购置申请
import flowData163 from '@/assets/img/flowData163@3x.png' // 办公用品购置申请
import oaFlowData162 from '@/assets/img/oaFlowData162@3x.png'  // 员工试用期合同签订
import oaFlowData161 from '@/assets/img/oaFlowData161@3x.png'  // 员工辞职申请表
import oaFlowData159 from '@/assets/img/oaFlowData159@3x.png'  // 员工工资调整申请表
import oaFlowData160 from '@/assets/img/oaFlowData160@3x.png'  // 员工转正审批表
import OaFlowDataCost from '@/assets/img/OaFlowDataCost@3x.png'  //  费用报销申请
import oaFlowData168 from '@/assets/img/oaFlowData168@3x.png'  // 付款审批单
import flowData194 from '@/assets/img/oaFlowData194@3x.png'  // 付款申请单
import oaFlowData193 from '@/assets/img/oaFlowData193@3x.png'  // 保证金审批单
import oaflowdata195 from '@/assets/img/oaFlowData195@3x.png'  // 工程检查情况通报
import oaFlowData169 from '@/assets/img/oaFlowData169@3x.png'  // 工程质量、安全隐患整改通知单
import oaFlowData170 from '@/assets/img/oaFlowData170@3x.png'  // 工程质量、安全隐患整改通知/回复单
import oaFlowData199 from '@/assets/img/oaFlowData199@3x.png'  // 项目进展情况追踪
import oaFlowData154 from '@/assets/img/oaFlowData154@3x.png'  // 工程项目进度管理
import oaFlowQjsq from '@/assets/img/oaFlowQjsq.jpg'  // 请假申请
import oaFlowBksq from '@/assets/img/oaFlowBksq.png'  // 补卡申请
import oaFlowXjsq from '@/assets/img/oaFlowXjsq.png'  // 补卡申请

const imgFlow = {
  flowData163,
  oaFlowData203,
  oaFlowData200,
  oaFlowData202,
  oaFlowData201,
  oaFlowData171,
  oaFlowData172,
  oaFlowData173,
  oaFlowData192,
  flowdata164,
  oaFlowData162,
  oaFlowData161,
  oaFlowData159,
  oaFlowData160,
  OaFlowDataCost,
  oaFlowData168,
  flowData194,
  oaFlowData193,
  oaflowdata195,
  oaFlowData169,
  oaFlowData170,
  oaFlowData199,
  oaFlowData154,
  oaFlowQjsq,
  oaFlowBksq,
  oaFlowXjsq
}
export {
  licenseType,
  licenseStatus,
  borrowStatus,
  imgFlow
}
